import * as React from "react";

interface IProps {
  version: string;
  os: string | null;
}

export class VersionCell extends React.Component<IProps> {
  public render() {
    const { os, version } = this.props;

    let osIcon: any = null;
    if (os === "android") {
      osIcon = (
        <img className="os-icon" src={require("../assets/android.svg")} />
      );
    } else if (os === "ios") {
      osIcon = <img className="os-icon" src={require("../assets/ios.svg")} />;
    }

    return (
      <span>
        {version} {osIcon}
      </span>
    );
  }
}

export default VersionCell;



// WEBPACK FOOTER //
// ./src/components/VersionCell.tsx